'use client';

import { Carousel } from '@zillow/constellation-10';
import { ListingCardPlaceholder } from '@/src/components/ListingCard/ListingCardPlaceholder';
import { carouselItem } from './listingCarousel.styles';

const PLACEHOLDER_SLOT_COUNT = 3;

/**
 * Loading rail for `ListingCard`s. Composed from the carousel's own header and
 * scroll container so it reserves the resolved rail's height without restating
 * Constellation's vertical padding, and without `Carousel`'s hooks, observers
 * or skip links — a placeholder needs the box, not the behaviour.
 */
export function ListingCarouselPlaceholder() {
  return (
    <div aria-hidden="true">
      <Carousel.Header />
      <Carousel.ScrollContainer slideGap="md">
        {Array.from({ length: PLACEHOLDER_SLOT_COUNT }, (_, index) => (
          <Carousel.Slide key={index} slideAlign="start">
            <div className={carouselItem}>
              <ListingCardPlaceholder />
            </div>
          </Carousel.Slide>
        ))}
      </Carousel.ScrollContainer>
    </div>
  );
}
